import { PageHeader } from '@ant-design/pro-layout';
import { Typography } from 'antd';
import { SubPageLayout } from '../sub-page-layout';
import { EntityEditContainer } from '../components/entity-edit.container';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export const EntityEdit: React.FC<any> = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Entity - Edit</title>
      </Helmet>
      <SubPageLayout
        header={<PageHeader title={<Typography.Title style={{ fontSize: '30px', marginTop: '12px' }}>Edit Entity</Typography.Title>} onBack={() => navigate(-1)}></PageHeader>}
      >
        <EntityEditContainer />
      </SubPageLayout>
    </>
  );
};
